module.exports = __webpack_public_path__ + "img/external.27c05bcc.jpg";